import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsModule, TooltipModule } from 'ngx-bootstrap';
import {RouterModule} from '@angular/router';
import {ReactiveFormsModule} from '@angular/forms';
import {NgxPaginationModule} from 'ngx-pagination';
import { SharedModule } from '../../../shared/shared/shared.module';
import { UserInfoComponent } from './user-info.component';
import { UserInfoUserEditComponent } from './user-edit/user-info-user-edit.component';
import { UserInfoHousingAccessComponent } from './user-housing-access/user-info-housing-access.component';
import { UserInfoHousingAccessAddModalComponent } from './user-housing-access-add-modal/user-info-housing-access-add-modal.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
  ],
  declarations: [
    UserInfoComponent,
    UserInfoUserEditComponent,
    UserInfoHousingAccessComponent,
    UserInfoHousingAccessAddModalComponent,
  ]
})
export class UserInfoModule { }
